import { render, staticRenderFns } from "./CreateAccountIndia.vue?vue&type=template&id=72926e36&scoped=true&"
import script from "./CreateAccountIndia.vue?vue&type=script&lang=js&"
export * from "./CreateAccountIndia.vue?vue&type=script&lang=js&"
import style0 from "./CreateAccountIndia.vue?vue&type=style&index=0&id=72926e36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72926e36",
  null
  
)

export default component.exports